export function runWebWorker(fn: any, arg: any) {
  return new Worker(
    URL.createObjectURL(new Blob(['(' + fn + ')(' + JSON.stringify(arg) + ')']))
  )
}
